module.exports = __webpack_public_path__ + "static/media/1417962043.d6015ae0.ttf";